var g_post_editor_contentHash;
var g_post_editor_isPublished;

document.addEventListener("documentChanged", async () => {
    await devtricker_post_edit_activateButtons();
});

// The editor Johannes fires the TextEditorLoaded event when it loads
// Setup the save buttons when editor load
document.addEventListener("TextEditorLoaded", () => {

    const saveDraftButton = document.getElementById('saveDraftPost');
    saveDraftButton.addEventListener('click', async () => saveChanges());

    const saveAndPublishButton = document.getElementById('saveAndPublish');
    saveAndPublishButton.addEventListener('click', async () => saveChangesAndPublish());

    const publishButton = document.getElementById('publishPost');
    publishButton.addEventListener('click', async function () {
        
        publishButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Publishing`;

        try {
            const result = await devtricker_main_saveCurrentEditingPost();;
            const publishResult = await devtricker_ajax_update_postage_status(result.data.post_id, "publish");
            window.location.href = publishResult.data.redirect_url;

        } catch (error) {
            publishButton.textContent = "Publish";
            devtricker_showPostToast(devtricker_createErrorToast('top', 10, error.message));
        }
    });

    const editor = document.getElementById("johannesEditor");

    editor.addEventListener("input", async () => {
        await devtricker_post_edit_activateButtons();
    });

    editor.addEventListener("keypress", async (event) => {
        if (event.key == "Backspace") {
            await devtricker_post_edit_activateButtons();
        }

        if (event.key == "Delete") {
            await devtricker_post_edit_activateButtons();
        }
    });

    editor.addEventListener("keydown", async (event) => {
        if (event.key.toLowerCase() == "s" && event.ctrlKey) {

            event.preventDefault();
            event.stopImmediatePropagation();

            await saveChanges();
        }
    }, true);


    const upload = document.querySelector("#devtricker_dom_setFeaturedImage");
    if (upload) {
        upload.addEventListener("click", devtricker_dom_promptFileUpload);
    }

    // label.addEventListener('click', () => {
    //     this.devtricker_dom_promptFileUpload();
    // });
});


async function saveChangesAndPublish() {
    const saveAndPublishButton = document.getElementById('saveAndPublish');

    saveAndPublishButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving changes`;
    saveAndPublishButton.setAttribute("disabled", true);

    try {
        const result = await devtricker_main_saveCurrentEditingPost();

        const publishResult = await devtricker_ajax_update_postage_status(result.data.post_id, "publish");
        window.location.href = publishResult.data.redirect_url;
        saveAndPublishButton.textContent = "Save changes";

    } catch (error) {
        saveAndPublishButton.textContent = "Save changes";
        devtricker_showPostToast(devtricker_createErrorToast('top', 10, error.message));
    }
}

async function saveChanges() {

    const saveDraftButton = document.getElementById('saveDraftPost');
    const saveAndPublishButton = document.getElementById('saveAndPublish');

    if (g_post_editor_isPublished && (!devtricker_post_edit_hasContentAndTitle() || !await devtricker_post_edit_hasChange())) {
        saveAndPublishButton.classList.add("x-shake-animation");

        setTimeout(() => {
            saveAndPublishButton.classList.remove("x-shake-animation");
        }, 1000);

        return;
    }

    if (!await devtricker_post_edit_hasChange()) {

        saveDraftButton.classList.add("x-shake-animation");

        setTimeout(() => {
            saveDraftButton.classList.remove("x-shake-animation");
        }, 1000);

        return;
    }

    saveDraftButton.textContent = "Saving...";
    saveDraftButton.setAttribute("disabled", true);

    saveAndPublishButton.textContent = "Saving changes...";
    saveAndPublishButton.setAttribute("disabled", true);

    try {
        const result = await devtricker_main_saveCurrentEditingPost();
        saveDraftButton.textContent = "Save Draft";
        saveAndPublishButton.textContent = "Save changes";

        await devtricker_post_edit_updateHash();

        const path = window.location.pathname;
        const segments = path.split('/');
        const postId = segments[2] || 0;

        if (postId == 0) {
            history.pushState({ page: 'edit' }, 'Edit Post', `/post/${result.data.post_id}/edit/`);
        }

    } catch (error) {
        saveDraftButton.textContent = "Save Draft";
        saveAndPublishButton.textContent = "Save changes";
        devtricker_showPostToast(devtricker_createErrorToast('top', 10, error.message));
    }
}

function devtricker_post_editPost(postId) {
    window.location.href = `/post/${postId}/edit/`;
}